<div *ngIf="!switchedToInput" class="container-slider-amount">
  <div class="container-slider-top" [ngClass]="{ 'container-slider-top-numeric': type === sliderTypes.numeric }">
    <label translate>{{ header }}</label>
    <div class="container" [ngClass]="{ 'edit-icon': type === sliderTypes.date, 'container-numeric': type === sliderTypes.numeric }">

      <!-- numeric logic here -->
      <ng-container *ngIf="type === sliderTypes.numeric">
        <div
          class="switch-to-input"
          (click)="handleSwitchToInput()"
          *ngIf="switchToInputText"
        >
          {{ 'slider.switchToInputLabel' | translate }}
        </div>
        <div class="amount-icon-container">
          <span class="container-slider-amount-span">{{ control.value | myCurrency }}</span>
          <div *ngIf="switchToInputText" class="icon icon-edit" (click)="handleSwitchToInput()">
          </div>
        </div>
      </ng-container>

      <!-- date logic here -->
      <ng-container *ngIf="type === sliderTypes.date">
        <span
          class="container-slider-date-span"
        >{{ control.value | duration : translate.instant('global.yearLabel') : translate.instant('global.monthLabel')}}</span>
        <div
          class="container-slider-container"
          [ngClass]="{ 'is-active': inputFocused }"
        >
          <input
            class="container-slider-amount-input"
            [formControl]="control"
            type="number"
            (blur)="handleInputBlur()"
            (focus)="handleInputFocus()"
          />
        </div>
      </ng-container>
    </div>
  </div>
  <nouislider [formControl]="control" [config]="config"></nouislider>
</div>
<div *ngIf="switchedToInput">
  <app-currency-input
    [label]="header"
    [control]="control"
    [error]="error"
  ></app-currency-input>
</div>
